import { ApolloClient, ApolloLink, NormalizedCacheObject, Observable } from '@apollo/client';
import { useAuth0 } from '../../auth';
import { getLink } from './links/getLink';
import { cache } from './cache';
import { useMemo } from 'react';
import { config } from '../environment';

const archiveLink = new ApolloLink(
  () =>
    new Observable(observer => {
      observer.next({});
      observer.complete();
    }),
);

export const useClient = (): ApolloClient<NormalizedCacheObject> => {
  const { getAccessTokenSilently } = useAuth0();
  return useMemo(() => {
    const link = config.platformMode === 'archive' ? archiveLink : getLink(getAccessTokenSilently);
    return new ApolloClient({ link, cache });
  }, [getAccessTokenSilently]);
};
